import { jsx as _jsx } from "react/jsx-runtime";
import { QVTableCellLink } from '../../components';
const createTableQVLink = ({ referrerData, additionalData, traitsType, }) => (function TableQVLink(_, rowData) {
    var _a, _b, _c, _d, _e;
    if (!rowData) {
        throw new Error('No rowData was provided for variants link!');
    }
    if (!traitsType) {
        throw new Error('No traitsType was provided for variants link!');
    }
    const { ancestry, variantId, pvalue, cases, gene, collapsingModel, phenotypeModelId, phenotypicCategory, geneModelId, } = rowData;
    // eslint-disable-next-line react/destructuring-assignment
    let phenotype = rowData.phenotype;
    // Have different assignments because data on each view is different
    // eslint-disable-next-line react/destructuring-assignment
    let categoryId = rowData.category_id
        || ((_a = phenotypicCategory) === null || _a === void 0 ? void 0 : _a.id);
    const collapsingModelId = (_c = geneModelId !== null && geneModelId !== void 0 ? geneModelId : (_b = collapsingModel) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : phenotypeModelId;
    const geneNameFromData = (_d = gene) === null || _d === void 0 ? void 0 : _d.name;
    if (additionalData) {
        const associationData = additionalData;
        phenotype = (_e = associationData.phenotype) !== null && _e !== void 0 ? _e : phenotype;
        categoryId = associationData.category ? associationData.category.id : categoryId;
    }
    if (!phenotype) {
        throw new Error('No phenotype was provided for variants link!');
    }
    if (!categoryId) {
        throw new Error('No category id was provided for variants link!');
    }
    return (_jsx(QVTableCellLink, { collapsingModelId: collapsingModelId, geneNameFromData: geneNameFromData, phenotypeId: phenotype.id, category: categoryId, traitsType: traitsType, label: variantId, referrerData: referrerData, pvalue: pvalue, cases: cases, ancestry: ancestry }, void 0));
});
export default createTableQVLink;
